import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { type NavigateFunction } from 'react-router-dom';
import { VendorCompanyService } from '../../services/wealthlane-customer-services';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';

const usePostCustomerStepOne = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setStep: (step: number) => void,
  navigate: NavigateFunction,
  id?: string,
  state?: unknown
): UseMutationResult => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (id !== null && id !== undefined) {
        return await handleRequest(
          VendorCompanyService.putApiCustomerApiAppVendorCompanyCompanyProfile(payload)
        );
      }
      return await handleRequest(
        VendorCompanyService.postApiCustomerApiAppVendorCompanyCompanyProfile(payload)
      );
    },
    {
      onSuccess: async (response: any, variables: any) => {
        if (response !== null && response !== undefined) {
          if (variables?.noNavigation) {
            toast.success(<ToastComponent label='Success' message={`Company Edited`} />);
            navigate(`/customer-list`, { replace: true, state });
          } else {
            setStep(2);
            navigate(`/customer-list/create/${String(response.id)}`, { replace: true, state });
          }
          await queryClient.invalidateQueries('getVendorCompanyView');
        }
      },
    }
  );
};

export default usePostCustomerStepOne;
